export const loadAdminArticleDetail = async ({ apiUrl, articleId, headers, fetchImpl = fetch }) => {
  const response = await fetchImpl(`${apiUrl}/api/admin/journal/${articleId}`, { headers });
  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    const error = new Error(errorBody.detail || "Impossible de charger le contenu complet de l'article.");
    error.status = response.status;
    throw error;
  }

  const article = await response.json();
  if (!Object.prototype.hasOwnProperty.call(article, 'content')) {
    throw new Error("Le contenu complet n'a pas été renvoyé. L'éditeur reste fermé par sécurité.");
  }
  return article;
};